// Import the functions you need from the SDKs you need
// import { firebase } from "firebase/app";

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDVi99ch9dzvn6jhSBk2exQ9G4rNclzyvU",
  authDomain: "dubdubtv-3e1d1.firebaseapp.com",
  projectId: "dubdubtv-3e1d1",
  storageBucket: "dubdubtv-3e1d1.appspot.com",
  messagingSenderId: "625533107288",
  appId: "1:625533107288:web:2ba34548712cbffef39e2d",
  measurementId: "G-6X62JQVDE9"
};

// Initialize Firebase
// const firebaseApp = firebase.initializeApp(firebaseConfig);
// const db = firebaseApp.firestore();

const app = initializeApp(firebaseConfig);
const db = getFirestore();

export { app, db };